export default () => ({
  reverseLookups: {},
});
